__turbopack_context__.v({
  "bar": "password-strength-module-scss-module__sgDR6W__bar",
  "root": "password-strength-module-scss-module__sgDR6W__root",
  "rule": "password-strength-module-scss-module__sgDR6W__rule",
  "rule_failed": "password-strength-module-scss-module__sgDR6W__rule_failed",
  "rule_icon": "password-strength-module-scss-module__sgDR6W__rule_icon",
  "rule_passed": "password-strength-module-scss-module__sgDR6W__rule_passed",
  "rule_untouched": "password-strength-module-scss-module__sgDR6W__rule_untouched",
  "rules": "password-strength-module-scss-module__sgDR6W__rules",
  "rules_wrapper": "password-strength-module-scss-module__sgDR6W__rules_wrapper",
  "segment": "password-strength-module-scss-module__sgDR6W__segment",
  "segment_empty": "password-strength-module-scss-module__sgDR6W__segment_empty",
  "segment_medium": "password-strength-module-scss-module__sgDR6W__segment_medium",
  "segment_strong": "password-strength-module-scss-module__sgDR6W__segment_strong",
  "segment_weak": "password-strength-module-scss-module__sgDR6W__segment_weak",
  "segments": "password-strength-module-scss-module__sgDR6W__segments",
});
